import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TouchpointNotificationPayload } from './touchpoint-notification.service';

export interface TouchpointNotificationSnackbarItem {
  message: string;
  notification: TouchpointNotificationPayload;
}

@Component({
  selector: 'app-touchpoint-notification-snackbar',
  templateUrl: './touchpoint-notification-snackbar.component.html',
  standalone: false,
})
export class TouchpointNotificationSnackbarComponent {
  constructor(
    private snackBarRef: MatSnackBarRef<TouchpointNotificationSnackbarComponent>,
    private router: Router,
    @Inject(MAT_SNACK_BAR_DATA) public data: { items: TouchpointNotificationSnackbarItem[], actionLabel: string },
  ) { }

  open(notification: TouchpointNotificationPayload): void {
    this.router.navigate(['/touchpoints'], {
      queryParams: notification.id ? { openTouchpointId: notification.id } : {},
    });
    this.snackBarRef.dismiss();
  }

  dismiss(): void {
    this.snackBarRef.dismiss();
  }
}
